<template>
  <div class="page rowBackgroundHomepage ">
    <div class="page-content">

      <div class="listPage">
        <div class="row showLargeScreenOnly"/>
        <BackButton returnUrl="/bankAccounts/" />
        <div class="row">
        <div class="col-md-12">
        </div>
      </div>
        <div class="itemList">
          <f7-list class="searchbar-found polsize" id="bank-list">
            <f7-list-item
              v-for="account in this.report"
              v-bind:media="'<i class=\'icon list-icon ' + getClassStatus(account.status) + '\'></i>'"
              class="bankAccountList boxRequest"
              :key="account.line - 1"
              :title="account.line - 1 + ': ' + account.name"
              :subtitle="account.status">{{account.description}}
            </f7-list-item>
          </f7-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import BackButton from '@/components/common/backButton.vue'

export default {
  name: 'ImportBankAccountReportList',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    BackButton
  },
  data: () => {
    return {
      report: []
    }
  },
  created () {
    this.$bus.on('refresh-bank-accounts-import-report', () => {
      this.report = []
      this.report = this.$engine.bankAccounts.getImportReport()
    })
    this.report = this.$engine.bankAccounts.getImportReport()
  },
  computed: {
    getReport () {
      return this.report
    }
  },
  methods: {
    getClassStatus (value) {
      var color = ''
      if (value === 1) {
        color = 'icon-account-green-bank'
      } else {
        color = 'icon-account-red-bank'
      }
      return color
    }
  }
}
</script>

<style>
.bankAccountList>.item-link>.item-content>.item-inner>.item-title-row>.item-title {
  color: #12bcf1 !important;
}
.polsize {
  font-size: 12px;
}
.icon-account-red-bank {
  background-image: url('../../assets/static/images/banks.png');
}
.icon-account-green-bank {
  background-image: url('../../assets/static/images/account.png');
}
</style>



// WEBPACK FOOTER //
// CMImportBankAccountReport.vue?fc4fad0c